import { ResponseData, Err } from 'types';

import { http } from '.';

export const getAccountData = async () => {
  return await http.get<Err, ResponseData<any>>(`/Accounts/GetAccountInfo`);
};

export const createAccount = async (payload) => {
  return await http.post<Err, ResponseData<number>>(`Accounts/Create`, payload);
};
export const getProfilePhoto = async () => {
  return await http.get<Err, Blob>(`/Accounts/GetProfilePhoto`, {
    headers: {
      Accept: 'application/octet-stream',
    },
    responseType: 'blob',
  });
};

export const getStamp = async () => {
  return await http.get<Err, Blob>(`/Accounts/GetStamp`, {
    headers: {
      Accept: 'application/octet-stream',
    },
    responseType: 'blob',
  });
};

export const getSignature = async () => {
  return await http.get<Err, Blob>(`/Accounts/GetSignature`, {
    headers: {
      Accept: 'application/octet-stream',
    },
    responseType: 'blob',
  });
};

export const updateAccountInfo = async (payload) => {
  return await http.post<Err, ResponseData<any>>(
    `/Accounts/UpdateAccountInfo`,
    payload
  );
};
